<template>
    <div class="chosedialog">
        <el-dialog :close-on-click-modal="false" v-bind="$attrs" v-on="$listeners" custom-class="body_dilog xuanzewuliao" append-to-body>
            <div class="h-rowIn" >
                <div class="h-rowBox">
                    <div class="h-rowCon yxline">
                        <div class="h-formbLine" style="margin-bottom: 1px;">
                            <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                                <el-form-item label="预测人" >
                                    <el-select v-model="q.ycrcode" @change="handleFilter" placeholder="请选择">
                                        <el-option
                                                v-for="item in ycrlist"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="产品编码/型号" >
                                    <el-input clearable v-model="q.wlcodename"></el-input>
                                </el-form-item>
                                <el-form-item label="预测单号" >
                                    <el-input clearable v-model="q.yccode"></el-input>
                                </el-form-item>
                                <el-form-item class="h-formBtnOut" style="margin-top:-11px;width:40%;">
                                    <el-button type="primary"  @click="handleFilter">搜索</el-button>

                                </el-form-item>
                            </el-form>
                        </div>
                        <el-table
                                max-height="500px"
                                size="mini"
                                ref="multipleTable"
								:border="true"
                                :data="ttdata"
                                tooltip-effect="dark"
                                style="width: 100%"
                                @selection-change="handleSelectionChange">
                            <el-table-column
                                    type="selection"
                                    fixed
                                    width="55">
                            </el-table-column>
                            <el-table-column
                                    prop="yccode"
                                    label="预测号"
                                    width="150" >
                            </el-table-column>

                            <el-table-column
                                    prop="yccountry"
                                    label="预测国家"
                                    width="150" >
                            </el-table-column>

                            <el-table-column
                                    prop="matecode"
                                    label="物料号"
                                    width="120"
									:show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="matedes"
                                    label="物料描述"
                                    width="190"
									:show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="oemDesc"
                                    label="规格型号"
                                    width="190"
                                    :show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="factory"
                                    label="产地"
                                    width="120"
                                    :show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="ycrname"
                                    label="预测人"
                                    width="150"
									:show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    {{ scope.row.ycrname }} {{ scope.row.ycrcode }}
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="isCustommed"
                                    label="是否定制"
                                    width="120"
                                    :show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    {{ scope.row.isCustommed|dictname('shifou_keyong') }}
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="extraDes"
                                    label="定制描述"
                                    width="150"
                                    :show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="availableNum"
                                    label="预测剩余可用数量"
                                    width="150"
                                    :show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="sfsp"
                                    label="预测是否超120天"
                                    width="150" >
                                <template slot-scope="scope">
                                    {{ scope.row.sfsp|shifouchao60 }}
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="delivery_method"
                                    label="直发/库发"
                                    width="120"
                                    :formatter = 'formatterZhifakufa'
                                    :show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="MEASURE"
                                    label="尺寸(长宽高)"
                                    width="90"
                                    :show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    {{ scope.row.MEASURE }}
                                </template>
                            </el-table-column>
                            <!--
                            <el-table-column
                                    prop="wlmaozh"
                                    label="毛重"
                                    width="90"
                                    :show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    {{ scope.row.wlmaozh+scope.row.wlzhongldw }}
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="wljinzh"
                                    label="净重"
                                    width="90"
                                    :show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    {{ scope.row.wljinzh+scope.row.wlzhongldw }}
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="wlzhongldw"
                                    label="重量单位"
                                    width="90"
                                    :show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="wltiji"
                                    label="体积"
                                    width="90"
                                    :show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    {{ scope.row.wltiji+scope.row.wltijidw }}
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="wltijidw"
                                    label="体积单位"
                                    width="90"
                                    :show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="currency"
                                    label="币种"
                                    width="110"
									:show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    v-if="dailishangFlag"
                                    prop="jizhj"
                                    label="基准价"
                                    width="110"
									:show-overflow-tooltip="true">
                            </el-table-column>
                            -->

                            <!--<el-table-column-->
                                    <!--prop="djyxq"-->
                                    <!--label="有效期"-->
                                    <!--width="110"-->
									<!--:show-overflow-tooltip="true">-->
                            <!--</el-table-column>-->

                        </el-table>
                        <div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
                            <paginationmin :page="q" @query="querypage"/>
                            <el-button type="primary"  @click="choseSelected">选择</el-button>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import ss from '../../api/SystemService'
    export default {
        data(){
          return {
              ycrlist: [{
                  value: 'my',
                  label: '我的预测'
              }, {
                  value: '',
                  label: '全部预测'
              }, {
                  value: 'c60',
                  label: '共用库存'
              }],
              q:{
                  pageSize:10,
                  pageNo:1,
                  total:0,
                  wlcodename:null,
                  usercode:null,
                  ddlx:null,
                  xmcode:null,
                  currencyCode:null,
                  customerChannelCode:null,
                  //预测号
                  yccode:null,
                  //预测国家
                  yccountry:null,
                  //预测人
                  ycrcode:'my',
                  country:null,

              },
              ttdata:null,
              lists:[],
              dailishangFlag: true,
              userRole: '',
          }
        },
        filters: {
            shifouchao60: function (value) {
                if(value == 3){
                    return "是"
                }
                return "否"
            }
        },
        methods: {
            handleFilter(){
                this.querypage();
            },
            formatterZhifakufa(row, cellValue) {

                if(row.protype=='OEM') {
                    //zhifakufa;//直发库发1：直发，2：库发
                    if (row.delivery_method == 1) {
                        return '直发'
                    } else if (row.delivery_method == 2) {
                        return '库发'
                    } else {
                        return ''
                    }
                }else{
                    return '自产'
                }
            },
            querypage(p){
                ss.wuliaoselect.selectWmPage(this.q).then(rd=>{
                    this.q.total = rd.total;
                    this.ttdata = rd.records;

                    this.userRole = this._user.roles;
                    this.userRole.forEach((item, index) => {
                        if (item.id == "swyl_dailishang") {
                            this.dailishangFlag = false;
                        }
                    })
                })
            },
            handleSelectionChange(lists){
                if(this.oneflag){
                    this.$emit('choseObj', lists[0])
                }else{
                    this.lists = lists;
                }
            },
            choseSelected(){
                this.$emit('choseObj', this.lists)
            },
        },
        created(){
            //订单类型
            this.q.ddlx = this.dingdLeix
            //项目编号
            this.q.xmcode = this.XmCode
            //经销商
            this.q.usercode = this.UserCode
            //币种
            this.q.currencyCode = this.currencyCode
            this.q.customerChannelCode = this.customerChannelCode
            this.q.country = this.countryCode
            this.querypage()
        },
        computed: {
            UserCode:function () {
                return this.usercode;
            },
            //订单类型
            dingdLeix:function () {
                return this.ddlx
            },
            //项目编码
            XmCode:function () {
                return this.xmcode
            },
        //    国家
            countryCode:function () {
                return this.country
            }
        },
        props: {
            dialogVisible: {
                type: Boolean,
            },
            usercode:{
                type:String,
            },
            //订单类型
            ddlx:{
                type:String,
            },
            oneflag:{
                type:Boolean,
            },
            xmcode:{
                type:String,
            },
            currencyCode:{
                type:String,
            },
            customerChannelCode:{
                type:String,
            },
            country:{
                type:String,
            }
        }
    }
</script>

<style>
    .xuanzewuliao .el-dialog__header{
        padding-top: 20px;
        padding-left: 20px;
    }
    .xuanzewuliao .el-dialog__body{
        padding: 20px;
    }
    .xuanzewuliao .el-table tbody td .cell {
        padding: 0.1rem 0.1rem !important;
    }
    .xuanzewuliao .h-formbLine .el-form-item__label{
        width: 39%;
    }
    .xuanzewuliao  .h-formbLine .el-form-item__content{
        width: 55%;
    }
    .xuanzewuliao .yxline .h-formbLine .el-form-item__content{
        width: 55%;
    }
    .xuanzewuliao .yxline{
        padding-top: 0;
    }
    .xuanzewuliao .h-pagination{
        padding-top: 0rem;
        padding-bottom: 0rem;
    }
    .xuanzewuliao .h-rowCon{
        padding-bottom: 0rem;
    }
</style>
